// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"je","contentFrame":"jf","buttonGroup":"jh","button":"ji","header":"jj","text":"jk","contentImage":"jl"};